import React from 'react';

import NoIcon from '@material-ui/icons/NotInterested'
import IconButton from '@material-ui/core/IconButton';

import classNames from 'classnames';
import { SermonGeniusSearchItem } from '../../../../services/GeniusSearchService';
import { EventTracking, SearchEntity } from '../../../../utilities/Tracking/EventTracking';
import StringHelper from "../../../../utilities/StringHelper";
import RatingHelper from "../../../../utilities/RatingHelper"
import { List, ListItem, ListItemText, Tooltip, Typography, Button, Divider, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    scriptureActionButtons: {
        display: 'flex',
        paddingBottom: 7,
        paddingLeft: 5
    },
    actionButtons: {
        fontSize: 13,
        textTransform: 'capitalize'
    },
    result: {
        padding: '0 16px',
        whiteSpace: 'normal',
        height: 'auto',
        '&:hover': {
            '&+div': {
                display: 'block'
            }
        }
    },
}));

interface Props {
    buttonText: string;
    disabled?: boolean;
    results: SermonGeniusSearchItem[];
    selected: (id: string) => void;
    copy: (searchItem: SermonGeniusSearchItem) => void;
    remove?: (id: string) => void;
}

export function SermonGeniusResultsList(props:Props){
    const {buttonText, disabled, results, selected, copy, remove} = props;
    const classes = useStyles();
    const showFull = (r:SermonGeniusSearchItem) => {
        r.id !== undefined ? selected(r.id) : selected(r.scriptureReference!);
        EventTracking.Builder.contentDrawerOpen(SearchEntity.Genius, "Genius Drawer Interaction");
    }

    return (
        <List>
        { results.slice(0, 5).map((r: SermonGeniusSearchItem) => {
            return (
            <React.Fragment key={r.id !== undefined ? r.id : r.scriptureReference}>
                <ListItem
                    className={classNames( classes.result)}
                    style={{ display: 'block' }}
                >
                    <ListItemText
                        primary={(
                        <>
                            <span dangerouslySetInnerHTML={{ __html: StringHelper.toTitleCase(r.title)}} />
                            { r.id !== undefined && remove !== undefined
                                &&
                            <span style={{ float: 'right', color: "#BBBBBB"}} >
                                <Tooltip title='Remove Result'>
                                    <IconButton style={{ padding: 5}} aria-label="Delete" disableRipple={true}
                                            onClick={() => remove(r.id!) }
                                            disabled={disabled}>
                                        <NoIcon fontSize="small" style={{color: "#BBBBBB"}}/>
                                    </IconButton>
                                </Tooltip>
                            </span>
                            }
                        </>
                        )}
                        secondary={(
                        <>
                            { r.rating !==undefined && r.id !== undefined
                                &&
                                <span>
                                    {r.contributor} | {RatingHelper.convertToStars(r.rating, r.id)}
                                </span>
                            }
                            <Typography component="span" variant="body2" dangerouslySetInnerHTML={{ __html: r.scriptureReference ? r.description : StringHelper.toShortenSentence(r.description, 100) }} />
                        </>
                    )}
                    />
                    <div className={classes.scriptureActionButtons}>
                        <Button size="small" 
                                className={classes.actionButtons} 
                                variant="text" 
                                color="primary"
                                onClick={() => copy(r) }>
                            Copy to clipboard
                        </Button>
                        <Button
                            size="small"
                            className={classes.actionButtons}
                            variant="text"
                            color="primary"
                            onClick={() => showFull(r)}
                        >
                            { buttonText } 
                        </Button>
                    </div>
                </ListItem>
                <Divider />
            </React.Fragment>
            )}
        )}
        </List>
    )
}